export default "__VITE_ASSET__ChU$maCv__"